import React, {useState, useEffect} from 'react';
import { ENGINE_URL } from '../../config';
import { cancelOrder } from '../business/Order';
import { useOrderContext } from '../OrderContext';

function CancelOrder()
{
    const {cancelData, orders, setOrders} = useOrderContext();
    const apiUrl = ENGINE_URL;

    const [reasons, setReasons] = useState(false);

    useEffect(() => {
        getReasons();
    },[]);

    function getReasons()
    {
        fetch(`${apiUrl}/server/public/`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                kitchen: "getReasons",
            })
        })
        .then((response) => {
            if(!response.ok)
            {
                return false;
            }

            return response.json();
        })
        .then((data) => {
            setReasons(data);
        })
        .catch((error) => console.error(error));
    }
    
    const handleCancelClick = () => {
        const reason = document.getElementById("reasons");

        let reasonId  = reason ? reason.value : null;

        cancelOrder(orders, setOrders, [reasonId, cancelData[0], cancelData[1]]); 
    }

    return (
        <div className="modal fade modal-dark" id="cancelOrder"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-dark">
                <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Відміна замовлення</h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                {
                    reasons && (
                        <select className="form-select form-select-lg mb-3" id='reasons'>
                        {
                            Object.values(reasons).map(item => {
                                return (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                )
                            })
                        }
                        </select>
                    )
                }
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Закрити</button>
                    <button type="button" onClick={handleCancelClick} data-bs-dismiss="modal" className="btn btn-danger">Відмінити</button>
                </div>
                </div>
            </div>
        </div>
    )
}

export default CancelOrder;